import { useState } from "react";
import "./FAQAccordion.css";
import arrow from "../images/FAQPage_arrow.svg";

const FAQAccordion = ({ question }) => {
    const [viewAnswer, setViewAnswer] = useState(false);

    const toggleView = () => {
        setViewAnswer(!viewAnswer);
    };

    return (
        <article className="faq-item">
            <button onClick={toggleView} className="faq-question">
                {question.question}
                <img
                    src={arrow}
                    className={`faq-arrow ${viewAnswer ? "rotate" : ""}`}
                    alt="arrow"
                />
            </button>
            <div className={`faq-answer-wrapper ${viewAnswer ? "open" : ""}`}>
                <div className="faq-answer">{question.answer}</div>
            </div>
        </article>
    );
};

export default FAQAccordion;
